// extracted by mini-css-extract-plugin
module.exports = {"component":"line-by-line_component__1ppk5","line":"line-by-line_line__2nG7O","isInViewport":"line-by-line_isInViewport__2exrp"};